module.exports = __webpack_public_path__ + "static/media/tabla.76b6496f.png";